<template>
	<div class="tab-instruction">
		<!-- <el-row>
			<el-button type="primary" @click="handleAdd('descriptionList')">新增</el-button>
			<el-button type="primary" @click="handleDelete('descriptionList')">删除</el-button>
		</el-row> -->

		<el-row>
			<el-table
			:data="info.descriptionList"
			style="margin-top: 10px"
			@select="handleSelectItem"
			border
			stripe>
			 <!-- <el-table-column
				type="selection"
				width="55">
				</el-table-column> -->
			<el-table-column
				:show-overflow-tooltip="true"
				property="imgUrl"
				label="图片"
				:min-width="150">
					<template slot-scope="scope">
						<img :src="scope.row.imgUrl| parseImgUrl" alt="" style="width: 100%;">
					</template>
				</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="componentCode"
				label="组件"
				:min-width="150"></el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="componentTypeVal"
				label="组件类型*"
				:min-width="100">
			</el-table-column>
			<el-table-column
				label="配色方案"
				:min-width="100">
				<el-table-column
					v-for="(item, $index) in info.gridCodeList"
					:key="`tab-special--${$index}`"
					:show-overflow-tooltip="true"
					property="materialDescCn"
					:label="item.colorName"
					:min-width="100">
					<template slot-scope="scope">
						<!-- gridCodeList colorCode -->
						<base-show-checkbox 
							:is-check="scope.row.codeList.findIndex(inner => item.colorCode == inner) > -1"></base-show-checkbox>
					</template>
				</el-table-column>
			</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="materialTypeVal"
				label="特殊工艺类型"
				:min-width="100">
				</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="usedPosition"
				label="部位"
				:min-width="100">
				</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="componentDesc"
				label="工艺内容项详情"
				:min-width="150">
				</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="vendorName"
				label="供应商名称"
				:min-width="120">
				</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="developer"
				label="开发员"
				:min-width="100">
				</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="joinCostAccountingFlag"
				label="核算"
				:min-width="100">
				</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="basicUnit"
				label="基本单位"
				:min-width="100">
				</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="supplyIndicator"
				label="供应标识"
				:min-width="100">
				</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				property="remark"
				label="备注"
				:min-width="100">
			</el-table-column>
		</el-table>
		</el-row>
	</div>
</template>
<script>
import { mixins } from './mixins';
import baseShowCheckbox from 'components/base-show-control/base-show-checkbox.vue';
export default {
	name: 'tab-special',
	props: {
		info: {
			type: Object,
			default: () => ({})
		},
		readOnly: {
			type: Boolean,
			default: false
		}
	},
	mixins: [mixins],
    components: {
		baseShowCheckbox
	},
	computed: {

	},
    methods: {

    },
    mounted() {
    },
    data() {
        return {
			labelConfig: {
				readOnly: true
			},
			list: []
        }
    }
}
</script>

<style scoped>
</style>
